import { createAsyncThunk } from '@reduxjs/toolkit'
import { showToast } from '../../../../shared/lib/showToast/showToast'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { fetchClientLabels } from '../../../DisplayClientLabels'
import { ClientLabelWithId } from '../../../../entities/ClientLabel'

export const editClientLabel = createAsyncThunk<
	void,
	ClientLabelWithId,
	ThunkConfig<string>>
(
	'editClientLabel',
	async (clientLabel, thunkAPI) => {
		const {
			dispatch,
			extra: { api },
			rejectWithValue
		} = thunkAPI

		const labelColor = clientLabel.labelColor && clientLabel.labelColor.length === 7 ?
			clientLabel.labelColor + 'D9' :
			clientLabel.labelColor

		const clientLabelDTO = { ...clientLabel, labelColor }

		try {
			await api.put(`/clientLabels/${clientLabel.labelId}`, clientLabelDTO)

			showToast({
				type: 'success',
				toastId: 'editClientLabel',
				message: 'Success'
			})

			dispatch(fetchClientLabels())
		} catch (e) {
			console.log(e)
			appHandleError(e, 'editClientLabel', 'Edit failed')
			return rejectWithValue('Error occurred while editing client label')
		}
	}
)
